<div class="container">
    <div class="header">
        <div class="header-content marginBottom20">
            <span class="custom1">Mercado Canalejas Madrid</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        <span class="custom2">Telemetría de consumos</span>

        <div class="fecha-personalizada">
            <div class="fechaPersonalizadaContaienr">
                <div class="fecha-personalizada-content">
                    <span class="custom3">Fecha personalizada:</span>
                    <mat-form-field class="fecha-form">
                        <mat-label class="rojo">Selecciona una fecha</mat-label>
                        <mat-date-range-input
                            [formGroup]="selectedDate"
                            [rangePicker]="selectedDatePicker">
                            <input matStartDate placeholder="Fecha inicio" formControlName="start" readonly>
                            <input matEndDate placeholder="Fecha fin" formControlName="end" readonly>
                        </mat-date-range-input>
                        <mat-hint>Día/Mes/Año</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="selectedDatePicker" class="rojo2"></mat-datepicker-toggle>
                        <mat-date-range-picker #selectedDatePicker></mat-date-range-picker>
                        <mat-error *ngIf="fechaPersonalizadaError">Elige un campo de inicio y fin</mat-error>
                    </mat-form-field>
                </div>

                <button mat-flat-button class="aplicar-btn" (click)="litrosConsumidosFechaPersonalizada()">Aplicar</button>

                <div class="consumoTotalContainer">
                    <span class="consumoTotalTitulo">CONSUMO TOTAL:</span>
                    <span class="consumoTotalResultado" *ngIf="consumoTotal !== undefined">{{soloDosDecimalesConComa(consumoTotal)}} L</span>
                    <ng-container *ngIf="consumoTotal === undefined">
                        <div class="loading-gifSpinner">
                            <img src="assets/images/canalejas/spinner.gif" 
                            alt="Cargando..."
                            class="customgif"/>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="generatePDFCompleto()">
                <mat-icon>download</mat-icon>
                <span>Generar informe completo</span>
            </button>
        </mat-menu>
    </div>

    <div class="body-tab">
        <mat-tab-group class="custom-tab-group" color="warn" (focusChange)="onTabFocusChange($event)">
            <mat-tab label="Diario" id="tab-diario">
                <div class="fecha-D">
                    <button mat-icon-button (click)="restarDiaFechaActual()"><mat-icon>keyboard_arrow_left</mat-icon></button>
                    <span [ngStyle]="{'color': fechaPersonalizada ? 'grey' : 'black'}">{{fechaActualD}}</span>
                    <button mat-icon-button (click)="sumarDiaFechaActual()"><mat-icon>keyboard_arrow_right</mat-icon></button>
                </div>
            </mat-tab>
            <mat-tab label="Semanal" id="tab-semanal">
                <div class="fecha-S">
                    <button mat-icon-button (click)="restarSemanaFechaActual()"><mat-icon>keyboard_arrow_left</mat-icon></button>
                    <span [ngStyle]="{'color': fechaPersonalizada ? 'grey' : 'black'}">{{fechaActualS}}</span>
                    <button mat-icon-button (click)="sumarSemanaFechaActual()"><mat-icon>keyboard_arrow_right</mat-icon></button>
                </div>
            </mat-tab>
            <mat-tab label="Mensual" id="tab-mensual">
                <div class="fecha-M">
                    <button mat-icon-button (click)="cambiarMesAnterior()"><mat-icon>keyboard_arrow_left</mat-icon></button>
                    <span [ngStyle]="{'color': fechaPersonalizada ? 'grey' : 'black'}">{{fechaActualM}}</span>
                    <button mat-icon-button (click)="cambiarMesSiguiente()"><mat-icon>keyboard_arrow_right</mat-icon></button>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div class="device-conainer">
        <div class="devices" *ngFor="let device of mercadoCanalejasDevices">
            <div class="device-header">
                <span class="custom4">{{device.dev_label}}</span>
                <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn custom5">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <span class="custom6">(Ref. {{device.dev_reference}})</span>
                <span class="custom7">Última lectura: {{(device.lastreader.created_at)}}</span>
            </div>

            <mat-menu #menu="matMenu">
                <button mat-menu-item [disabled]="litrosConsumidosPorDispositivo[device.dev_reference] === undefined"
                (click)="generatePDF(device.dev_label, device.dev_reference, device.options[0].dev_option_value, soloDosDecimalesConComa(litrosConsumidosPorDispositivo[device.dev_reference]))">
                    <mat-icon>download</mat-icon>
                    <span>Generar informe</span>
                </button>
            </mat-menu>
            
            <div class="device-body">
                <div class="estado-conexion-tipo-cerveza">
                    <div class="estado-conexion">
                        <span>ESTADO CONEXIÓN</span>
                        <div [class]="getDeviceStatus(device.lastreader.created_at)" class="connection-value marginTop10">
                            <i class="material-icons font40">wifi</i>
                        </div>
                    </div>
                    <div class="tipo-cerveza marginLeft15P">
                        <span>TIPO DE CERVEZA</span>
                        <div class="beertype-value">
                            <img *ngIf="parseJSONOptions(device.options[0].dev_option_value) == '1' || parseJSONOptions(device.options[0].dev_option_value) == undefined" 
                            src="assets/images/canalejas/beertype-1.png" 
                            alt="Tipo de cerveza: Estrella Galicia"
                            class="cutom8"/>
                            <img *ngIf="parseJSONOptions(device.options[0].dev_option_value) === '2'" 
                            src="assets/images/canalejas/beertype-2.png" 
                            alt="Tipo de cerveza: Estrella Galicia 1906"
                            class="cutom8"/>
                        </div>
                    </div>
                </div>
                <div class="litros-consumidos">
                    <ng-container *ngIf="litrosConsumidosPorDispositivo[device.dev_reference] !== undefined && errorMessage == ''">
                        <div class="consumo-value">{{soloDosDecimalesConComa(litrosConsumidosPorDispositivo[device.dev_reference])}}</div>
                    </ng-container>
                    <ng-container *ngIf="litrosConsumidosPorDispositivo[device.dev_reference] === undefined && errorMessage == ''">
                        <div class="loading-gif">
                            <img src="assets/images/canalejas/loading.gif" 
                            alt="Cargando..."
                            class="custom9"/>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="errorMessage !== ''">
                        <div class="mensaje-error">{{ errorMessage }}</div>
                    </ng-container>
                    <!--
                    <ng-container *ngIf="errorMessage === ''">
                        <div class="consumo-value">{{litrosConsumidosPorDispositivo[device.dev_reference]}}</div>
                    </ng-container>
                    <ng-container *ngIf="errorMessage !== ''">
                        <div class="consumo-value">{{errorMessage}}</div>
                    </ng-container>-->
                    <span>LITROS CONSUMIDOS</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>
